import dayjs from "dayjs";

const imageExtention = ["image/gif", "image/jpeg", "image/png"];

export default {
  formatToSentDateTime(date, tz, keepLocalTime = false) {
    if (!date) return null;
    if (typeof date === "string") {
      date = date.replace(/-/g, "/").replace("T", " ");
    }
    if (tz) {
      return dayjs(new Date(date))
        .tz(tz, keepLocalTime)
        .format();
    } else {
      return date;
    }
  },
  formatDateTime(date, tz) {
    if (!date) return null;
    if (typeof date === "string") {
      date = date.replace(/-/g, "/").replace("T", " ");
    }
    if (tz) {
      return dayjs(new Date(date))
        .tz(tz)
        .format("DD-MM-YYYY HH:mm:ss");
    } else {
      return date;
    }
  },
  formatServerDateTime(date, tz) {
    if (!date) return null;
    if (typeof date === "string") {
      date = date.replace(/-/g, "/").replace("T", " ");
    }
    if (tz) {
      return dayjs(new Date(date))
        .tz(tz)
        .format("YYYY-MM-DD HH:mm:ss");
    } else {
      return date;
    }
  },
  formatDate(date, tz) {
    if (!date) return null;
    if (typeof date === "string") {
      date = date.replace(/-/g, "/").replace("T", " ");
    }
    if (tz) {
      return dayjs(new Date(date))
        .tz(tz)
        .format("DD-MM-YYYY");
    } else {
      // return dayjs().format("DD-MM-YYYY");
      return date;
    }
  },
  formatServerDate(date, tz) {
    if (!date) return null;
    if (typeof date === "string") {
      date = date.replace(/-/g, "/").replace("T", " ");
    }
    if (tz) {
      return dayjs(new Date(date))
        .tz(tz)
        .format("YYYY-MM-DD");
    } else {
      // return dayjs().format("YYYY-MM-DD");
      return date;
    }
  },
  urlQueryString(data, allowNULL = true) {
    return Object.keys(data)
      .map(function(key) {
        if (!allowNULL && !data[key]) {
          return false;
        }
        return [key, data[key]].map(encodeURIComponent).join("=");
      })
      .filter(val => val)
      .join("&");
  },
  parameterizeArray(key, arr) {
    if (!arr || !key) return;
    arr = arr.map(encodeURIComponent);
    return key + "[]=" + arr.join("&" + key + "[]=");
  },
  /**
   * Only pick that is matched on object vs template
   * @param object
   * @param template
   */
  pick(object, template) {
    return _.pick(object, template);
  },

  /**
   * Check whether object is matched or not
   * @param object
   * @param template
   * @returns {object|null}
   */
  mandatory(object, template) {
    let match = _.pick(object, template);
    if (Object.keys(match) && Object.keys(match).length == template.length) {
      return object;
    } else {
      return null;
    }
  },

  /**
   * Generate a Desciprtion for Beli > Listrik
   * @param danon
   * @returns {string}
   */
  genListrikDescription(danon) {
    return "Token Listrik" + " " + new Intl.NumberFormat().format(danon);
  },

  /**
   * Generate a Desciprtion for Beli > Pulsa
   * @param danon
   * @returns {string}
   */
  genPulsaDescription(cellular_name, danon) {
    return (
      "Pulsa" +
      " " +
      cellular_name +
      " " +
      new Intl.NumberFormat().format(danon)
    );
  },

  formatPhone: function(phone) {
    console.warn("Deprecation warning: Should use this.formatPhone");
    phone = phone.replace(/(\d{4})(\d{3})(\d{4})/, "($1)-$2-$3");
    return phone;
  },
  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  },
  isImage: function(file) {
    if (file && file.type && imageExtention.indexOf(file.type) > -1)
      return true;
    return false;
  },
  setCookie(name, value, days) {
    let expires = "";
    if (days) {
      let date = new Date();
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
  },
  getCookie(name) {
    let nameEQ = name + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  validUserName(name) {
    console.warn("Deprecation warning: Should use this.validUserName");
    let regex = /^[+][0-9]{6,}$/;
    return regex.test(name);
  },
  validPin(pin) {
    console.warn("Deprecation warning: Should use this.validPin");
    let regex = /^[0-9]{6,6}$/;
    return regex.test(pin);
  },
  fmtMSS(s) {
    console.warn("Deprecation warning: Should use this.fmtMSS");
    return (s - (s %= 60)) / 60 + (9 < s ? ":" : ":0") + s;
  },
  showAmount(value) {
    console.warn("Deprecation warning: Should use this.showAmount");
    return value ? parseInt(value).toLocaleString("en-US") : 0;
  },
  getStatus(configData, type, field) {
    console.warn("Deprecation warning: Should use this.getStatus");
    return configData[type] && configData[type][field]
      ? configData[type][field]
      : "";
  },

  getErrorMessageOrDefault(error, text) {
    if (
      error.response &&
      error.response.data &&
      error.response.data.error &&
      error.response.data.error.code === 400 &&
      error.response.data.error.message
    ) {
      return error.response.data.error.message;
    }

    return text;
  },
  addEllipsisFx(string, num) {
    let result = "";
    result = string ? string.slice(0, num) + " ..." : result;
    return result;
  },
  handleArrayByQuantity(array) {
    // array = [{
    //   id: 1,
    //   quantity: 1,
    // }]
    let arrResult = array.reduce((acc, it) => {
      if (acc.length === 0) {
        return [...acc, it];
      } else {
        let found = acc.find(a => a.id === it.id);
        if (!found) {
          acc = [...acc, it];
        } else {
          found.quantity = found.quantity + 1;
        }
        return acc;
      }
    }, []);
    return arrResult;
  },
  flattenTree(data) {
    if (!_.isArray(data)) return [];

    const result = [];

    function traverse(parentId) {
      data.forEach((item) => {
        if (item.parent_id === parentId) {
          result.push(item);
          traverse(item.id);
        }
      });
    }

    traverse(null);
    return result;
  },
  isInViewHeight(el) {
    if (!_.isElement(el)) return;

    const rect = el.getBoundingClientRect();
    const viewHeight = window.innerHeight || document.documentElement.clientHeight;
    return rect.top >= 0 && rect.bottom <= viewHeight;
  },
  scrollToFirstError(selectors, top = 100) {
    let selectorArr = [
      "input.is-danger:first-of-type",
      ".v-select.is-danger:first-of-type",
      ".select.is-danger:first-of-type",
    ];
    let elArr = [];

    if (_.isArray(selectors)) selectorArr = [...selectorArr, ...selectors];

    if (_.isString(selectors)) selectorArr = [...selectorArr, selectors];

    selectorArr.forEach(x => {
      const xArr = [...document.querySelectorAll(x)];

      if (xArr.length) elArr = [...elArr , ...xArr];
    });

    if (elArr.some(x => this.isInViewHeight(x))) return;

    const el = elArr.find(x => !(this.isInViewHeight(x)));
    const rect = el.getBoundingClientRect();

    if (el) {
      window.scrollTo({
        top: rect.top + window.scrollY - top,
        behavior: 'smooth'
      });
    }
  }
};
